/* Fiber Society front-end behaviors. No dependencies. */
(function () {
  'use strict';

  /* ---------- scroll reveal ---------- */
  function initReveal() {
    var els = document.querySelectorAll('.fs-reveal');
    if (!els.length || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (el) { io.observe(el); });
    /* safety net: never leave content invisible (anchor jumps, odd timing) */
    setTimeout(function () {
      els.forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.top < window.innerHeight && r.bottom > 0) el.classList.add('is-in');
      });
    }, 700);
    setTimeout(function () {
      els.forEach(function (el) { el.classList.add('is-in'); });
    }, 2500);
  }

  /* ---------- sticky mobile add-to-cart (product page) ---------- */
  function initStickyAtc() {
    var bar = document.querySelector('.fs-sticky-atc');
    if (!bar) return;
    document.body.appendChild(bar); /* escape transformed ancestors so fixed works */
    var buyBox = document.querySelector('.product-form__buttons');
    if (!buyBox || !('IntersectionObserver' in window)) return;
    function setBarVisible(visible) {
      bar.classList.toggle('is-visible', visible);
      /* keep aria-hidden and focusability in sync with visibility */
      bar.setAttribute('aria-hidden', visible ? 'false' : 'true');
      bar.querySelectorAll('button').forEach(function (b) { b.tabIndex = visible ? 0 : -1; });
    }
    setBarVisible(false);
    var io = new IntersectionObserver(function (entries) {
      setBarVisible(!entries[0].isIntersecting);
    }, { rootMargin: '-80px 0px 0px 0px' });
    io.observe(buyBox);
    var btn = bar.querySelector('[data-fs-sticky-buy]');
    if (btn) {
      btn.addEventListener('click', function () {
        buyBox.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    }
  }

  /* ---------- per-serving price (product page) ---------- */
  function initPerServing() {
    var el = document.querySelector('[data-fs-perserving]');
    if (!el) return;
    var data;
    try { data = JSON.parse(el.getAttribute('data-fs-perserving')); } catch (err) { return; }
    var stickyPrice = document.querySelector('[data-fs-sticky-price]');
    function update() {
      var params = new URLSearchParams(window.location.search);
      var vid = params.get('variant') || el.getAttribute('data-fs-default');
      var v = data[vid];
      if (!v) return;
      el.querySelector('[data-fs-ps-value]').textContent = v.perServing;
      var note = el.querySelector('[data-fs-ps-note]');
      if (note) note.textContent = v.note || '';
      if (stickyPrice) stickyPrice.textContent = v.price;
    }
    update();
    document.addEventListener('change', function (e) {
      if (e.target.closest('variant-selects, variant-radios, .product-form__input')) {
        setTimeout(update, 150);
        setTimeout(update, 800);
      }
    });
  }

  /* ---------- cart actions: adds, plan toggle, swap upsell, plan switch ---------- */
  function cartRequest(path, body, btn, restoreLabel) {
    var cartDrawer = document.querySelector('cart-drawer');
    body.sections = ['cart-drawer', 'cart-icon-bubble'];
    body.sections_url = window.location.pathname;
    return fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.sections && cartDrawer && typeof cartDrawer.renderContents === 'function') {
          cartDrawer.renderContents(res);
          cartDrawer.classList.remove('is-empty');
          var inner = cartDrawer.querySelector('.drawer__inner');
          if (inner) inner.classList.remove('is-empty');
        } else if (!res.sections) {
          window.location.reload();
        }
        if (btn) { btn.disabled = false; if (restoreLabel) btn.textContent = restoreLabel; }
        return res;
      });
  }

  function initDrawerUpsell() {
    /* one-time / subscription toggle on offer cards */
    document.addEventListener('click', function (e) {
      var opt = e.target.closest('[data-fs-ot]');
      if (!opt) return;
      var group = opt.closest('.fs-offer-toggle');
      group.querySelectorAll('[data-fs-ot]').forEach(function (o) {
        o.setAttribute('aria-checked', o === opt ? 'true' : 'false');
      });
      var card = opt.closest('.fs-offer-card');
      var member = opt.getAttribute('data-fs-ot') === 'member';
      var addBtn = card && card.querySelector('[data-fs-upsell-add]');
      if (addBtn) {
        addBtn.textContent = member
          ? (addBtn.getAttribute('data-fs-label-member') || addBtn.textContent)
          : (addBtn.getAttribute('data-fs-label-onetime') || addBtn.textContent);
      }
      if (card) {
        card.querySelectorAll('[data-fs-ov]').forEach(function (el) {
          el.hidden = el.getAttribute('data-fs-ov') !== (member ? 'member' : 'onetime');
        });
      }
    });

    /* switch a one-time line to a subscription */
    document.addEventListener('click', function (e) {
      var sw = e.target.closest('[data-fs-switch-line]');
      if (!sw) return;
      e.preventDefault();
      sw.disabled = true;
      sw.textContent = ((window.fsI18n || {}).switching || 'Switching\u2026');
      cartRequest('cart/change.js', {
        id: sw.getAttribute('data-fs-switch-line'),
        quantity: Number(sw.getAttribute('data-fs-switch-qty')) || 1,
        selling_plan: Number(sw.getAttribute('data-fs-switch-plan'))
      });
    });

    /* smart upgrade: replace single pouches with the 2-pouch pack (preserving any subscription) */
    document.addEventListener('click', function (e) {
      var swap = e.target.closest('[data-fs-upsell-swap]');
      if (!swap) return;
      e.preventDefault();
      swap.disabled = true;
      swap.textContent = ((window.fsI18n || {}).upgrading || 'Upgrading\u2026');
      var duoId = Number(swap.getAttribute('data-fs-upsell-swap'));
      var singleId = Number(swap.getAttribute('data-fs-single'));
      /* the 2-pouch variant has its own selling plan, so a subscription
         upgrade must use its plan id, never the single pouch's */
      var duoPlanId = Number(swap.getAttribute('data-fs-duo-plan')) || null;
      fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
        var singles = cart.items.filter(function (i) { return i.variant_id === singleId; });
        var hadPlan = singles.some(function (i) { return i.selling_plan_allocation; });
        var planId = duoPlanId;
        var chain = Promise.resolve();
        singles.forEach(function (line) {
          chain = chain.then(function () {
            return fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ id: line.key, quantity: 0 })
            });
          });
        });
        chain.then(function () {
          var item = { id: duoId, quantity: 1 };
          if (hadPlan && planId) item.selling_plan = planId;
          return cartRequest('cart/add.js', { items: [item] });
        });
      });
    });

    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-fs-upsell-add]');
      if (!btn) return;
      e.preventDefault();
      var variantId = btn.getAttribute('data-fs-upsell-add');
      if (!btn.getAttribute('data-fs-label')) btn.setAttribute('data-fs-label', btn.textContent.trim());
      btn.disabled = true;
      btn.textContent = ((window.fsI18n || {}).adding || 'Adding…');
      var item = { id: Number(variantId), quantity: 1 };
      var card = btn.closest('.fs-offer-card');
      if (card) {
        var memberOpt = card.querySelector('[data-fs-ot="member"][aria-checked="true"]');
        if (memberOpt) item.selling_plan = Number(memberOpt.getAttribute('data-fs-ot-plan'));
      }
      cartRequest('cart/add.js', { items: [item] }, btn, btn.getAttribute('data-fs-label'))
        .catch(function () {
          btn.disabled = false;
          btn.textContent = 'Add';
        });
    });
  }

  /* ---------- custom purchase module (PDP) ---------- */
  function initBuyModule() {
    var root = document.querySelector('.fs-buy');
    if (!root) return;
    var cfg;
    try { cfg = JSON.parse(root.getAttribute('data-fs-buy')); } catch (e) { return; }
    var moneyFormat = root.getAttribute('data-fs-money-format') || '${{amount}}';
    var I18N = window.fsI18n || {};
    function tt(k, fb) { return (I18N[k] != null ? I18N[k] : fb); }
    function money(cents) {
      var amt = cents / 100;
      var mm = moneyFormat.match(/\{\{\s*(amount[a-z_]*)\s*\}\}/); var key = mm ? mm[1] : 'amount'; var str;
      var thousands = function (x, sep) { return x.replace(/\B(?=(\d{3})+(?!\d))/g, sep); };
      if (key === 'amount_no_decimals') str = thousands(String(Math.round(amt)), ',');
      else if (key === 'amount_with_comma_separator') str = thousands(amt.toFixed(2).replace('.', ','), '.');
      else if (key === 'amount_no_decimals_with_comma_separator') str = thousands(String(Math.round(amt)), '.');
      else if (key === 'amount_with_apostrophe_separator') str = thousands(amt.toFixed(2), "'");
      else if (key === 'amount_no_decimals_with_space_separator') str = thousands(String(Math.round(amt)), ' ');
      else if (key === 'amount_with_space_separator') str = thousands(amt.toFixed(2).replace('.', ','), ' ');
      else str = thousands(amt.toFixed(2), ',');
      return moneyFormat.replace(/\{\{\s*amount[^}]*\}\}/, str).replace(/[.,]00(\s|$)/, '$1').trim() || ('$' + amt);
    }
    var state = { pack: null, plan: 'onetime' };
    /* start from what the server rendered (selected_or_first_available_variant,
       which already honours a valid ?variant=), so module, native radios and
       the form's hidden id input agree before Dawn's product-info.js loads */
    var preset = root.querySelector('[data-fs-pack][aria-checked="true"]');
    state.pack = Number(preset && preset.getAttribute('data-fs-pack')) || cfg.variants[0].id;
    /* membership is the default purchase type when the variant offers it */
    if (cfg.variants.some(function (v) { return v.sub; })) state.plan = 'member';

    function variantOf(id) { return cfg.variants.find(function (v) { return v.id === id; }); }

    /* the live native picker. Dawn swaps <variant-selects> by inserting the
       fresh server copy BEFORE the old one and removing the old one ~500ms
       later, so the first match inside this product-info is the current one */
    function nativePicker() {
      return (root.closest('product-info') || document).querySelector('variant-selects, variant-radios');
    }
    var renderPending = false, queuedAdd = false, pendingTimer = null;
    function markRenderPending() {
      renderPending = true;
      clearTimeout(pendingTimer);
      /* safety net: a fetch that errors never publishes variantChange */
      pendingTimer = setTimeout(function () { renderPending = false; queuedAdd = false; }, 6000);
    }
    function syncNativeVariant() {
      var v = variantOf(state.pack);
      var picker = nativePicker();
      if (!v || !picker) return;
      picker.querySelectorAll('input[type=radio]').forEach(function (r) {
        if (r.value === v.title && !r.checked) {
          r.checked = true;
          var ev = new Event('change', { bubbles: true });
          ev.fsInternal = true; /* our own proxy event: the watcher below must ignore it */
          markRenderPending();
          r.dispatchEvent(ev);
        }
      });
    }
    function syncNativePlan() {
      /* the subscriptions app renders one section per variant */
      var sections = document.querySelectorAll('.shopify_subscriptions_app_block[data-variant-id]');
      sections.forEach(function (sec) {
        if (Number(sec.getAttribute('data-variant-id')) !== state.pack) return;
        var target = state.plan === 'member' ? 'selling_plan' : 'one_time_purchase';
        var input = sec.querySelector('input[data-radio-type="' + target + '"]');
        if (input && !input.checked) {
          input.checked = true;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    }

    /* the module is the accessible purchase UI; take the visually-hidden
       native controls out of the accessibility tree and tab order so
       screen-reader/keyboard users don't meet two sets of controls */
    function hideNativeControls() {
      var sel = '.product__info-wrapper variant-selects, ' +
        '.product__info-wrapper .product-form__input--pill, ' +
        '.product__info-wrapper .product-form__input--dropdown, ' +
        '.product__info-wrapper .product-form__quantity, ' +
        '.product__info-wrapper .shopify_subscriptions_app_block, ' +
        '.product__info-wrapper .product-form__submit';
      document.querySelectorAll(sel).forEach(function (el) {
        el.setAttribute('aria-hidden', 'true');
        var focusables = [];
        if (el.matches('button, input, select, textarea, a[href], [tabindex]')) focusables.push(el);
        el.querySelectorAll('button, input, select, textarea, a[href], [tabindex]').forEach(function (f) { focusables.push(f); });
        focusables.forEach(function (f) { f.setAttribute('tabindex', '-1'); });
      });
    }

    function paint() {
      var v = variantOf(state.pack);
      root.querySelectorAll('[data-fs-pack]').forEach(function (card) {
        var on = Number(card.getAttribute('data-fs-pack')) === state.pack;
        card.setAttribute('aria-checked', on ? 'true' : 'false');
      });
      root.querySelectorAll('[data-fs-plan]').forEach(function (card) {
        var on = card.getAttribute('data-fs-plan') === state.plan;
        card.setAttribute('aria-checked', on ? 'true' : 'false');
      });
      var oneEl = root.querySelector('[data-fs-plan-price="onetime"]');
      var memEl = root.querySelector('[data-fs-plan-price="member"]');
      if (oneEl) oneEl.textContent = money(v.price);
      if (memEl && v.sub) memEl.textContent = money(v.sub) + (v.freq ? ' ' + v.freq : '');
      var saveEl = root.querySelector('[data-fs-plan-save]');
      if (saveEl && v.sub && v.price > v.sub) {
        saveEl.textContent = tt('save_pct', 'Save __PCT__%').replace('__PCT__', Math.round((1 - v.sub / v.price) * 100));
      }
      var sv1 = root.querySelector('[data-fs-plan-servings]');
      var sv2 = root.querySelector('[data-fs-plan-servings2]');
      if (sv1) sv1.textContent = v.servings;
      if (sv2) sv2.textContent = v.servings;
      var freqLabel = root.querySelector('[data-fs-freq-label]');
      if (freqLabel && v.freq) freqLabel.textContent = v.freq;
      var freqName = root.querySelector('[data-fs-freq-name]');
      if (freqName && v.planName) freqName.textContent = v.planName;
      var freq = root.querySelector('[data-fs-freq]');
      if (freq) freq.hidden = state.plan !== 'member';
      var sub = root.querySelector('[data-fs-reassure-sub]');
      if (sub) sub.hidden = state.plan !== 'member';
      var cta = root.querySelector('[data-fs-cta]');
      var isMember = state.plan === 'member' && v.sub;
      var price = isMember ? v.sub : v.price;
      cta.textContent = (isMember ? tt('subscribe_prefix', 'Subscribe \u00b7') + ' ' : tt('add_prefix', 'Add') + ' ') + v.short + ' — ' + money(price) + (isMember ? ' ' + (v.freq || tt('every_4_weeks', 'every 4 weeks')) : '');
      var ps = root.querySelector('[data-fs-buy-ps]');
      if (ps) {
        var per = price / v.servings;
        ps.textContent = money(Math.round(per)) + ' ' + tt('per_glass', 'per glass') + ' · ' + v.servings + ' ' + tt('servings', 'servings');
      }
      /* sticky bar mirror */
      var sp = document.querySelector('[data-fs-sticky-price]');
      if (sp) sp.textContent = money(price) + (isMember ? (v.freq ? ' ' + v.freq : '') + ' · ' + tt('subscription', 'subscription') : ' · ' + tt('one_time_lc', 'one-time'));
      var sTitle = document.querySelector('.fs-sticky-info b');
      if (sTitle) sTitle.textContent = v.short + (isMember ? ' · ' + tt('subscription', 'subscription') : '');
    }

    root.addEventListener('click', function (e) {
      var pack = e.target.closest('[data-fs-pack]');
      if (pack) {
        state.pack = Number(pack.getAttribute('data-fs-pack'));
        queuedAdd = false;
        syncNativeVariant();
        setTimeout(function () { syncNativePlan(); hideNativeControls(); }, 250); /* widget swaps its section after variant change */
        paint();
        return;
      }
      var plan = e.target.closest('[data-fs-plan]');
      if (plan) {
        state.plan = plan.getAttribute('data-fs-plan');
        syncNativePlan();
        paint();
        return;
      }
      var cta = e.target.closest('[data-fs-cta]');
      if (cta) {
        syncNativeVariant();
        syncNativePlan();
        var nativeBtn = document.querySelector('.product-form__submit');
        if (nativeBtn) {
          cta.classList.add('is-loading');
          setTimeout(function () { cta.classList.remove('is-loading'); }, 2500);
          /* Dawn disables its submit while the variant re-render is in
             flight; queue the add until variantChange instead of dropping it */
          if (renderPending) { queuedAdd = true; return; }
          nativeBtn.click();
        }
      }
    });

    /* keep module state honest if the native picker is somehow used.
       Read the control that changed, synchronously. Never read ?variant=
       here: Dawn only rewrites the URL after its section fetch resolves, so
       a timed read of location.search returns the PREVIOUS variant. */
    document.addEventListener('change', function (e) {
      if (e.fsInternal) return;
      if (!e.target.closest || !e.target.closest('variant-selects, variant-radios')) return;
      markRenderPending();
      var v = cfg.variants.find(function (x) { return x.title === e.target.value; });
      if (v && v.id !== state.pack) { state.pack = v.id; paint(); }
    });

    /* Dawn finished re-rendering for a variant: its fresh <variant-selects>
       and the subscription widget need our sync + a11y treatment again */
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, function (evt) {
        var id = evt && evt.data && evt.data.variant && evt.data.variant.id;
        if (!id || !variantOf(id)) return; /* another product (quick add) */
        renderPending = false;
        clearTimeout(pendingTimer);
        if (id !== state.pack) { syncNativeVariant(); return; } /* stale render: re-assert the latest pick */
        if (queuedAdd) {
          queuedAdd = false;
          syncNativePlan();
          var nb = document.querySelector('.product-form__submit');
          if (nb) nb.click();
        }
        setTimeout(function () { syncNativePlan(); hideNativeControls(); }, 250);
      });
    }

    syncNativeVariant();
    syncNativePlan();
    hideNativeControls();
    paint();
    /* Dawn swaps parts of the product form on variant URL changes; re-assert */
    setTimeout(hideNativeControls, 1200);

    /* sticky bar CTA adds the current selection directly */
    var stickyBtn = document.querySelector('[data-fs-sticky-buy]');
    if (stickyBtn) {
      var fresh = stickyBtn.cloneNode(true);
      stickyBtn.parentNode.replaceChild(fresh, stickyBtn);
      fresh.addEventListener('click', function () {
        var nativeBtn = document.querySelector('.product-form__submit');
        if (nativeBtn) nativeBtn.click();
      });
    }
  }

  /* ---------- add-to-cart feedback: Added state + SR announcement ---------- */
  function initAtcFeedback() {
    var live = document.createElement('div');
    live.setAttribute('aria-live', 'polite');
    live.setAttribute('role', 'status');
    live.className = 'visually-hidden';
    document.body.appendChild(live);
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (evt) {
        if (!evt || evt.source !== 'product-form') return;
        live.textContent = ((window.fsI18n || {}).added_to_cart || 'Added to cart.');
        var btn = document.querySelector('.product-form__submit');
        if (btn) {
          var span = btn.querySelector('span') || btn;
          if (!btn.getAttribute('data-fs-orig')) btn.setAttribute('data-fs-orig', span.textContent.trim());
          span.textContent = ((window.fsI18n || {}).added || 'Added \u2713');
          setTimeout(function () { span.textContent = btn.getAttribute('data-fs-orig'); }, 2200);
        }
      });
    }
  }

  /* ---------- nutrition facts slide-over (PDP) ---------- */
  function initFactsPanel() {
    var wrap = document.querySelector('[data-fs-facts]');
    if (!wrap) return;
    /* escape transformed/animated ancestors so position:fixed works and the
       panel can scroll + close reliably */
    document.body.appendChild(wrap);
    var openers = document.querySelectorAll('[data-fs-facts-open]');
    if (!openers.length) return;
    var panel = wrap.querySelector('.fs-facts-panel');
    var lastFocus = null;
    function open() {
      lastFocus = document.activeElement;
      wrap.hidden = false;
      document.body.classList.add('fs-facts-lock');
      void wrap.offsetHeight; /* reflow so the transition runs */
      wrap.classList.add('is-open');
      panel.focus();
    }
    function close() {
      wrap.classList.remove('is-open');
      document.body.classList.remove('fs-facts-lock');
      setTimeout(function () { wrap.hidden = true; }, 280);
      if (lastFocus) lastFocus.focus();
    }
    openers.forEach(function (o) { o.addEventListener('click', open); });
    wrap.querySelectorAll('[data-fs-facts-close]').forEach(function (el) {
      el.addEventListener('click', close);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !wrap.hidden) close();
    });
  }

  /* ---------- pre-lander sticky CTA: appears once the product is revealed ---------- */
  function initArtSticky() {
    var bar = document.querySelector('[data-fs-art-sticky]');
    if (!bar) return;
    var anchor = document.querySelector('.fs-art-cta, .fs-art-item--pick, .fs-art-offer');
    if (!anchor) { bar.classList.add('is-visible'); return; }
    function check() {
      if (anchor.getBoundingClientRect().top < window.innerHeight) {
        bar.classList.add('is-visible');
        window.removeEventListener('scroll', check);
      }
    }
    window.addEventListener('scroll', check, { passive: true });
    check();
  }

  /* ---------- pre-lander offer box: pick a pack, every link to the product follows it ---------- */
  function initArtOffer() {
    var boxes = document.querySelectorAll('.fs-art-offer');
    if (!boxes.length) return;
    function pathOf(href) {
      try { return new URL(href, window.location.origin).pathname; } catch (e) { return null; }
    }
    function withVariant(a, id) {
      try {
        var u = new URL(a.getAttribute('href'), window.location.origin);
        u.searchParams.set('variant', id);
        a.setAttribute('href', u.pathname + u.search + u.hash);
      } catch (e) {}
    }
    boxes.forEach(function (box) {
      var rows = Array.prototype.slice.call(box.querySelectorAll('[data-fs-offer-pick]'));
      var cta = box.querySelector('[data-fs-offer-cta]');
      if (!rows.length || !cta) return;
      var path = pathOf(cta.getAttribute('href'));
      function pick(row) {
        var id = row.getAttribute('data-fs-offer-pick');
        rows.forEach(function (r) {
          var on = r === row;
          r.setAttribute('aria-checked', on ? 'true' : 'false');
          r.classList.toggle('fs-art-offer-row--hi', on);
        });
        /* the offer CTA, the sticky bar and the in-article CTAs all open the product with this pack */
        document.querySelectorAll('a[href]').forEach(function (a) {
          if (pathOf(a.getAttribute('href')) === path) withVariant(a, id);
        });
      }
      rows.forEach(function (row) {
        row.addEventListener('click', function () { pick(row); });
        row.addEventListener('keydown', function (e) {
          var k = e.key;
          if (k !== 'ArrowDown' && k !== 'ArrowUp' && k !== 'ArrowRight' && k !== 'ArrowLeft') return;
          e.preventDefault();
          var i = rows.indexOf(row) + (k === 'ArrowDown' || k === 'ArrowRight' ? 1 : -1);
          var next = rows[(i + rows.length) % rows.length];
          next.focus();
          pick(next);
        });
      });
    });
  }

  function init() {
    initArtSticky();
    initArtOffer();
    initReveal();
    initFactsPanel();
    initAtcFeedback();
    initBuyModule();
    initStickyAtc();
    initPerServing();
    initDrawerUpsell();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
